import { Link } from "@inertiajs/react";
import Menu from "~/components/Menu.jsx";
import Cart from "@/components/Cart.jsx";
import { cart_path } from "@/routes.js";
import logo from "../images/logo.png";
import { Button } from "~/components/ui/button.jsx";
import MobileMenu from "~/components/MobileMenu.jsx";
import DesktopNavigation from "~/components/DesktopNavigation.jsx";
import HeaderSearch from "./HeaderSearch";

export default function (props) {
  return (
    <header className="bg-white fixed top-0 inset-x-0 shadow-xs z-50">
      
      <div className="mx-auto container lg:px-0">
        <div className="flex h-16 items-center justify-between relative">
          <div className="size md:flex md:items-center md:gap-12">
            <Link className="block text-teal-600" href="/">
              <span className="sr-only">Главная</span>
              <img
                src={logo}
                className="ml-4 size-16 p-3 bg-white rounded"
                alt={""}
              />
            </Link>
          </div>

          <nav
            aria-label="Global"
            className="hidden md:flex items-center space-x-4"
          >
            <DesktopNavigation />
            <HeaderSearch />
          </nav>
          <div className="md:flex md:items-center md:gap-12">
            <div className="flex items-center gap-4">
              <div className="sm:flex sm:gap-4">
                <Button variant="ghost" className="px-0" size={"xl"} asChild>
                  <Link href={cart_path()}>
                    <Cart />
                  </Link>
                </Button>
              </div>

              <div className="block md:hidden">
                <MobileMenu />
                <button className="rounded-sm bg-gray-100 p-2 text-gray-600 transition hover:text-gray-600/75 hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="size-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto lg:hidden  px-2 py-2">
        <HeaderSearch />
      </div>
    </header>
  );
}
